import { QueryEntity } from '@datorama/akita';

import { GuestSurveyState, guestSurveyStore } from './guest-survey.store';
import { switchMap } from 'rxjs/operators';

export class GuestSurveyQuery extends QueryEntity<GuestSurveyState> {
  guestSurvey = this.selectActive();

  guestSurveys = this.select(({ ui }) => ui).pipe(
    switchMap(ui =>
      this.selectAll({
        filterBy: [
          x => !ui.guestId || ui.guestId === x.guestId,
          x => {
            if (!ui.startDate) return true;
            if (!x.completedTime) return false;
            var startDate = new Date(ui.startDate);
            var completedDate = new Date(x.completedTime);

            startDate.setHours(0, 0, 0, 0);
            completedDate.setHours(0, 0, 0, 0);

            // Compare only the date portion, ignoring the time
            return startDate.getTime() <= completedDate.getTime();
          },
          x => {
            if (!ui.endDate) return true;
            if (!x.completedTime) return false;
            var endDate = new Date(ui.endDate);
            var completedDate = new Date(x.completedTime);

            endDate.setHours(0, 0, 0, 0);
            completedDate.setHours(0, 0, 0, 0);

            return endDate.getTime() >= completedDate.getTime();
          },
          x => !!ui.outreachCompleted === x.outreachCompleted,
        ],
        sortBy: (a, b) => {
          const aTime = a.completedTime ? new Date(a.completedTime).getTime() : 0;
          const bTime = b.completedTime ? new Date(b.completedTime).getTime() : 0;

          return aTime - bTime;
        },
      })
    )
  );

  pagination = this.select(({ pagination }) => pagination);

  loading = this.selectLoading();
}

export const guestSurveyQuery = new GuestSurveyQuery(guestSurveyStore);
